import type { ApplicationContext } from '@hc-frontend/core-context';
import type { Log } from '@hc-frontend/features-logger';

import type { PublishCount } from '../../domain';

interface DatadogPublisherCountFactory {
  (log: ApplicationContext['log']): PublishCount;
}

export const createDatadogPublisherCount: DatadogPublisherCountFactory =
  (log: ApplicationContext['log']) => async (metric) => {
    const metricAsLog: Log = {
      message: metric.name,
      data: metric.tags,
      context: 'client',
      type: 'info',
    };
    log(metricAsLog);
  };
